import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { useState } from "react";
import ProductSelectorMain from "../../../selectors/product-selector/component/product-selector-main";
import { genElObject } from "../../../../components/utils/EditorDialogElementGenerator";

const ReportTemplateFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;
  const [showProductSelector, setShowProductSelector] = useState(false);

  const handleOnConfirmProduct = (event, datas) => {
    event.preventDefault();
    if (datas && datas.length > 0) {
      const ids = datas.map(d => d.id).join(",");
      const names = datas.map(d => d.name).join(", ");
      setFilterValue({ ...filterValue, data_product_names: names, product_id: ids });
      setShowProductSelector(false);
    }
  };

  const elProduct = genElObject({
    field: "product_id",
    name: "Product",
    value: filterValue?.data_product_names || (filterValue?.data_product ? filterValue.data_product.name : ""),
    onClick: () => setShowProductSelector(true),
    onClear: filterValue?.product_id
      ? () => setFilterValue({ ...filterValue, data_product: null, data_product_names: null, product_id: null })
      : undefined,
  });

  return (
    <div className="col-start-start w-full gap-2">
      <ProductSelectorMain
        multiple={true}
        title="Select Product"
        visible={showProductSelector}
        onHide={() => setShowProductSelector(false)}
        onConfirm={handleOnConfirmProduct}
      />

      <div className="row-start-end gap-2 w-full">
        <div className="row-start-start gap-3 w-full">
          <div className="col-start-start gap-1 w-[25rem]">{elProduct}</div>

          <div className="col-start-start gap-1 w-[30rem]">
            <label className="font-bold text-sm text-slate-500">Periode</label>
            <div className="row-start-center gap-2">
              <Calendar
                className="w-full"
                value={filterValue?.start_date}
                onChange={(e) => setFilterValue({ ...filterValue, start_date: e.value })}
                dateFormat="dd-mm-yy"
                showIcon
                showButtonBar
              />
              <span className="text-sm text-slate-500">S/D</span>
              <Calendar
                className="w-full"
                value={filterValue?.end_date}
                onChange={(e) => setFilterValue({ ...filterValue, end_date: e.value })}
                dateFormat="dd-mm-yy"
                showIcon
                showButtonBar
              />
            </div>
          </div>
        </div>

        <Button
          icon="pi pi-refresh"
          rounded
          onClick={() => onClickRefresh?.()}
          tooltip="Generate"
          tooltipOptions={{ position: "top" }}
        />
      </div>
    </div>
  );
};

export default ReportTemplateFilter;
